import React from "react";

interface ShimmerTextProps {
  text: string;
  color?: string;
}

const ShimmerText = ({ text, color = "#3E68FE" }: ShimmerTextProps) => (
  <div style={styles.textWrapper}>
    <span style={{ ...styles.baseText, WebkitTextFillColor: "transparent" }}>{text}</span>
    <span
      style={{
        ...styles.shimmerText,
        backgroundImage: `linear-gradient(90deg, transparent, ${color}, transparent)`,
      }}>
      {text}
    </span>
    <style>{keyframes}</style>
  </div>
);

const styles = {
  textWrapper: {
    position: "relative",
    overflow: "hidden",
    background: "transparent",
  } as React.CSSProperties,
  baseText: {
    fontSize: 18,
    fontWeight: 500,
    color: "transparent",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
  } as React.CSSProperties,
  shimmerText: {
    position: "absolute",
    inset: 0,
    backgroundSize: "200% 100%",
    animation: "shimmer 2s infinite linear",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    color: "transparent",
  } as React.CSSProperties,
};

const keyframes = `
  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

export default ShimmerText;
